import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import {
  DragRotateAndZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { BingMaps, XYZ } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'trackerAll',

  templateUrl: './trackerAll.component.html',

})

export class TrackerAllComponent implements OnInit {

  map: any = {};

  car: any;

  Id: string = "0";

  point: Array<any> = [];

  pointLive: Array<any> = [];

  flon: any;

  fLat: any;

  interval: any;

  Name: string = "";

  Plak: string = "";

  speed: string = "";

  mapSatelait: boolean = false;

  layers: any = [];

  tooltipData: any;

  source: any;

  vector: any;

  groupCar: any;

  domain: any;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private route: ActivatedRoute,
    private _location: Location,
    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    setTimeout(() => {

      this.newOpenMap();

      this.liveGetCar();

    }, 500);

    setTimeout(() => {

      this.map.on('pointermove', (e: any) => {

        if (e.dragging) return;

        var el = this.mapService.mapPointerMove(this.map.getEventPixel(e.originalEvent), this.map);

        //Handel cursor

        var pixel = this.map.getEventPixel(e.originalEvent);

        var hit = this.map.hasFeatureAtPixel(pixel);

        this.map.getViewport().style.cursor = hit ? 'pointer' : '';

        this.showData(el, true);


      });

      this.map.on('click', (e: any) => {

        if (e.dragging) {

          //...

          return;

        }

        setTimeout(() => {

          var el = this.mapService.mapPointerMove(this.map.getEventPixel(e.originalEvent), this.map);

          this.showData(el);

        }, 250);

      });

      this.map.getView().on('propertychange', (e: any) => {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

        this.tooltipData = null;

      });

    }, 1500);


  }

  newOpenMap() {

    this.source = new VectorSource({ wrapX: false });

    this.vector = new VectorLayer({

      source: this.source,

    });


    if (this.bOfflineMap) {

      this.layers.push(

        new TileLayer({

          source: new XYZ({

            // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

            url: this.strMapUrl,

            attributions: 'Map data © RayanAndishehNasr' // 

          }),

        })

      );

    }

    else {

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      let i, ii;

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                            key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


              imagerySet: styles[i],

            }),

          }),

        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


    }

    this.map = new Map({
      controls: defaultControls().extend([]),
      layers: this.layers,
      target: 'map',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 13,
      }),
    });

  }

  fitMap(data?: any) {

    if (data == null) data = this.car;

    var maxLatitude = data.fLat;

    var maxLongitude = data.fLon;

    var minLatitude = data.fLat;

    var minLongitude = data.fLon;

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      maxLongitude,

      maxLatitude,

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      minLongitude,

      minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
      // Math.min(transformedStart[0], transformedEnd[0]) - 2000,
      // Math.min(transformedStart[1], transformedEnd[1]) - 2000,
      // Math.max(transformedStart[0], transformedEnd[0]) + 2000,
      // Math.max(transformedStart[1], transformedEnd[1] + 2000)
    ];

    view.fit(source);
  }

  showData(item: any, hover?: any) {

    var tooltip: any;
    if (!hover) {
      tooltip = $('#map_tooltip');
    } else {
      tooltip = $('#map_tooltips');
    }

    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature.get('data')) {
        if (!hover) {

          this.tooltipData = item.featureLayer.feature.get('data').html;
          tooltip
            .attr(
              'data-bs-original-title',
              item.featureLayer.feature.get('data').html
            )

            .tooltip('show');

          var hoverTooltip = $('#map_tooltips');
          hoverTooltip.tooltip('hide');
        } else {
          if (this.tooltipData == item.featureLayer.feature.get('data').html) {
            return
          } else {
            ///////
            tooltip
              .attr(
                'data-bs-original-title',
                item.featureLayer.feature.get('data').html2
              )

              .tooltip('show');
          }
        }

        $('#map-button').click(() => {
          this.router.navigate([
            `/carInfo/${item.featureLayer.feature.get('data').Id}`,
          ]);
          tooltip.tooltip('hide');
          var hoverTooltip = $('#map_tooltip');
          hoverTooltip.tooltip('hide');
        });
      }
    } else {
      tooltip.tooltip('hide');
      this.tooltipData = null;
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');

  }

  changeTail() {

    if (this.mapSatelait == false) {
      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);
    }
    else {
      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);
    }
    this.mapSatelait = !this.mapSatelait;

  }

  liveGetCar = async () => {

    var model = {};

    this.mapService.removeLayerByName(`route_point`, this.map);

    this.mapService.removeLayerByName(`route_start`, this.map);

    this.mapService.removeLayerByName(`route_end`, this.map);

    this.mapService.removeLayerByName(`ArrowName`, this.map);

    var url_strong = window.location.href.toLowerCase();

    var split = url_strong.split("isystemuser=")

    var param = split[1];

    this.otherService.Showspinner();

    const resp = await axios.post(`GetAllCar4DrawLive_InWeb?iSystemUser=${param}`, model);

    this.otherService.nonespinner();

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    if (resp.data == null) {

      this.notifyService.showError('بروز خطا در سامانه');

      return;

    }



    else {

      resp.data.forEach((el: any, i: any) => {

        if (this.point.length != 0) {

          this.mapService.removeMarkerById(`route${i}`, this.map);

          this.mapService.removeMarkerById(`route${i}_start`, this.map);

          this.mapService.removeMarkerById(`route${i}_end`, this.map);

          this.mapService.removeLayerByName(`ArrowName`, this.map);

          this.mapService.removeLayerByName(`route_line`, this.map);

          this.mapService.removeLayerByName(`route_point`, this.map);

        }

        this.point.push({

          index: i,

          fLon: el.fLon,

          fLat: el.fLat,

          iAngle: el.siAngle,

          strTime: el.strTime,

          iSpeed: el.iSpeed,

          id: el.strUnitId,

          carName: el.strFullName,

          strMobileDomain: el.strMobileDomain_strComment,

          strMobileGroup: el.strMobileGroup_strComment,

          strMobileType: el.strMobileType_strComment

        });
        this.pointLive = this.point.filter((els: any) => {

          return els.id == el.strUnitId

        });

        this.mapService.drawRouteAnimate(`route${i}`, this.map, this.pointLive, resp.data[i], true, true);

      });
      if (resp.data.length > 0) {
        this.mapService.fitMap(resp.data, this.map);
      }
    }

    clearInterval(this.interval);
    this.interval = setInterval(async () => {
      const resp = await axios.post(`GetAllCar4DrawLive_InWeb?iSystemUser=${param}`, model);

      if (resp.data.ISSessionExpired == true) {
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }
      if (resp.data == null) {
        this.notifyService.showError('بروز خطا در سامانه');
        return;
      }
      else {

        if (this.point.length != 0) {
          this.mapService.removeLayerByName(`route_point`, this.map);
          this.mapService.removeLayerByName(`route_start`, this.map);
          this.mapService.removeLayerByName(`route_end`, this.map);
          this.mapService.removeLayerByName(`ArrowName`, this.map);
          this.mapService.removeLayerByName(`route_line`, this.map);
        }
        resp.data.forEach((el: any, i: any) => {
          this.point.push({
            index: i,
            fLon: el.fLon,
            fLat: el.fLat,
            iAngle: el.siAngle,
            strTime: el.strTime,
            iSpeed: el.iSpeed,
            id: el.strUnitId,
            carName: el.strFullName,
            strMobileDomain: el.strMobileDomain_strComment,
            strMobileGroup: el.strMobileGroup_strComment,
            strMobileType: el.strMobileType_strComment
          });

          this.pointLive = this.point.filter((els: any) => {

            return els.id == el.strUnitId
          });
          if (this.pointLive.length > 10) {

            this.pointLive.shift();

            this.point.splice(this.pointLive[0].index, 1);
          }

          this.mapService.drawRouteAnimate(`route${i}`, this.map, this.pointLive, resp.data[i], true, true);

          this.pointLive.forEach((element: any, index: number) => {

            if (index % 3 === 0) {

              if (index > 1) {

                this.mapService.removeLayerByName("Arrow", this.map);

                if (this.flon != this.pointLive[index - 1].fLon && this.fLat != this.pointLive[index - 1].fLat) {

                  this.flon = this.pointLive[index - 1].fLon;

                  this.fLat = this.pointLive[index - 1].fLat;

                  if (this.pointLive[index - 1].fLon != 0 && this.pointLive[index - 1].fLat != 0) {

                    var marker = this.mapService.craeteArrow([this.pointLive[index - 1].fLon, this.pointLive[index - 1].fLat],

                      '../../../assets/Img/16.png',

                      `Arrow`,

                      `ArrowName`,

                      {
                        html: `
                        
                           <span class="text-danger">زمان : ${this.pointLive[index - 1].strTime}</span>
                           <br />
                           
                           <span class="text-danger">سرعت : ${this.pointLive[index - 1].iSpeed}</span>
                           <br />
                           
                           <span class="text-black">حوزه خدمت : ${this.pointLive[index - 1].strMobileDomain}</span>
                           <br />
                           
                           <span class="text-black">نوع خودرو : ${this.pointLive[index - 1].strMobileType}</span>
                          
                       `,

                      },

                      this.pointLive[index - 1].iAngle

                    );

                    this.map.addLayer(marker);

                  }

                }

              }

            }

            //this.showArrowbtn = false;

          });

        });

      }

    }, 30000);

  }

}
